import { IS_SERVER } from "../common";
import {
  path,
  KAFKA_EVENT_CODES,
  Logger,
} from "./index";

/**
 * Отправка логов в Кафку при открытии формы регистрации
 */
const logForOpenRegForm = (imprint) => {
  if (IS_SERVER) return
  const { regStart } = KAFKA_EVENT_CODES;

  Logger.add(
    regStart,
    {
      sourceScreen: 'landing_form',
      refer: path
    },
    imprint
  );
}

/**
 * Отправка логов при вводе символов (телефон / email)
 */
const logForEnteredCharInRegForm = (regType, imprint) => {
  if (IS_SERVER) return
  const { enteredCharInReg } = KAFKA_EVENT_CODES;

  Logger.add(
    enteredCharInReg,
    {
      type: regType
    },
    imprint
  );
}

/**
 * Отправка логов при нажатии на кнопку "зарегистрироваться"
 */
const logForRegButtonEnter = (regType, value, countryId, currencyId, promocode, result, error, imprint) => {
  if (IS_SERVER) return
  const { regButtonEnter } = KAFKA_EVENT_CODES;

  Logger.add(
    regButtonEnter,
    {
      type: regType,
      value,
      countryId,
      currencyId,
      promocode,
      result,
      ...(error && { error })
    },
    imprint
  );
}

/**
 * Отправка логов при введении кода подтверждения из смс
 */
const logForSmsCodeEntered = (result, imprint) => {
  if (IS_SERVER) return
  const { smsCodeEntered } = KAFKA_EVENT_CODES;

  Logger.add(
    smsCodeEntered,
    {
      result
    },
    imprint
  );

}

/**
 * Отправка логов при повторном запросе отправки кода подтверждения
 */
const logForSmsCodeRepeat = (result, error, imprint) => {
  if (IS_SERVER) return
  const { smsCodeRepeat } = KAFKA_EVENT_CODES;

  Logger.add(
    smsCodeRepeat,
    {
      result,
      ...(error && { error })
    },
    imprint
  );
}

/**
 * Отправка логов при возврате на предыдущий шаг (Step 2 --> Step 1)
 */
const logForBackStep = ({ step }, imprint) => {
  if (IS_SERVER) return
  const { backStep } = KAFKA_EVENT_CODES;

  Logger.add(
    backStep,
    {
      step
    },
    imprint
  );

}

/**
 * Отправка логов при завершении регистрации
 */
const logForRegistrationDone = (imprint) => {
  if (IS_SERVER) return
  const { registrationDone } = KAFKA_EVENT_CODES;

  Logger.add(registrationDone, {}, imprint);

}

/**
 * Отправка логов в Кафку при отмене фокуса номера телефона в форме регистрации
 */
const logForLostFocusPhone = (value, imprint) => {
  if (IS_SERVER) return
  const { enteredPhone } = KAFKA_EVENT_CODES;

  Logger.add(
    enteredPhone,
    {
      value
    },
    imprint
  );
}

/**
 * Отправка логов в Кафку при отмене фокуса email в форме регистрации
 */
const logForLostFocusEmail = (value, imprint) => {
  if (IS_SERVER) return
  const { enteredEmail } = KAFKA_EVENT_CODES;

  Logger.add(
    enteredEmail,

    {
      value
    },
    imprint
  );

  // send(imprint);
}

/**
 * Отправка логов в Кафку при изменении страны
 */
const logForSelectCountry = (imprint, selectedCountryId, time, establishedCountryId) => {
  if (IS_SERVER) return
  const { choseCountry } = KAFKA_EVENT_CODES;

  Logger.add(
    choseCountry,
    {
      selectedCountryId,
      time,
      establishedCountryId,
    },
    imprint
  );

}

/**
 * Отправка логов в Кафку при отмене фокуса пароля в форме регистрации
 */
const logForEnteredPassword = (imprint) => {
  if (IS_SERVER) return
  const { enteredPassword } = KAFKA_EVENT_CODES;

  Logger.add(
    enteredPassword,
    {
    },
    imprint
  );

}

/**
 * Отправка логов в Кафку при изменении валюты
 */
const logForChangeСurrency = (value, imprint) => {
  if (IS_SERVER) return
  const { choseСurrency } = KAFKA_EVENT_CODES;

  Logger.add(
    choseСurrency,
    {
      value
    },
    imprint
  );
}

export {
  logForOpenRegForm,
  logForEnteredCharInRegForm,
  logForRegButtonEnter,
  logForSmsCodeEntered,
  logForSmsCodeRepeat,
  logForBackStep,
  logForRegistrationDone,
  logForLostFocusPhone,
  logForLostFocusEmail,
  logForSelectCountry,
  logForEnteredPassword,
  logForChangeСurrency
}